import { Injectable, Inject } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import { ProfileService } from './profile.service';
import * as Globals from './globals';
@Injectable()
export class HeaderService {
  constructor(@Inject(Http) private http: Http, private profileService: ProfileService) { }
  getHeader() {
    let headers = new Headers({ 'Authorization': 'Bearer ' + this.profileService.token });
    return headers;
  }
  //userCredential() {
  //    let headers = new Headers({ 'Authorization': 'Bearer ' + this.profileService.token });
  //    return this.http.get(Globals.serviceUrl + 'ref/user?secureCode=' + Globals.getClientName(), { headers: headers })
  //        .map(this.extractData);
  //}
  private extractData(res: Response) {
    let body = res.json();
    return body.PROFILE || {};
  }
  getFormatLocalDate(date: any) {
    var d = new Date(date || Date.now()),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    var monthName = '';
    switch (month) {
      case '1':
        monthName = 'Jan';
        break;
      case '2':
        monthName = 'Feb';
        break;
      case '3':
        monthName = 'Mar';
        break;
      case '4':
        monthName = 'Apr';
        break;
      case '5':
        monthName = 'Mei';
        break;
      case '6':
        monthName = 'Jun';
        break;
      case '7':
        monthName = 'Jul';
        break;
      case '8':
        monthName = 'Aug';
        break;
      case '9':
        monthName = 'Sep';
        break;
      case '10':
        monthName = 'Oct';
        break;
      case '11':
        monthName = 'Nov';
        break;
      case '12':
        monthName = 'Des';
        break;
      default:
        monthName = 'Jan';
        break;
    }
    return [day, monthName].join(' ');
  }
  getFormatLocalDate2(date: any) {
    var d = new Date(date || Date.now()),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    var monthName = '';
    switch (month) {
      case '1':
        monthName = 'Jan';
        break;
      case '2':
        monthName = 'Feb';
        break;
      case '3':
        monthName = 'Mar';
        break;
      case '4':
        monthName = 'Apr';
        break;
      case '5':
        monthName = 'Mei';
        break;
      case '6':
        monthName = 'Jun';
        break;
      case '7':
        monthName = 'Jul';
        break;
      case '8':
        monthName = 'Aug';
        break;
      case '9':
        monthName = 'Sep';
        break;
      case '10':
        monthName = 'Oct';
        break;
      case '11':
        monthName = 'Nov';
        break;
      case '12':
        monthName = 'Des';
        break;
      default:
        monthName = 'Jan';
        break;
    }
    return [day, monthName, year].join(' ');
  }
  getApiFormatDate(date: any) {
    var d = new Date(date || Date.now()),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }
  getApiFormatDate2(date:any){
    var d = new Date(date || Date.now()),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear(),
    hours = d.getHours(),
    minutes = d.getMinutes(),
    mili = d.getMilliseconds();
    // console.log(d);
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    var full = [year, month, day].join('-');
    // return [year, month, day].join('-');
    var time = [hours, minutes, mili].join(':')
    return [full, time].join(' ');
  }
  getApiFormatDate3(date: any) {
    var d = new Date(date || Date.now()),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [day, month, year].join('');
  }
  getApiFormatDate4(date: any) {
    var d = new Date(date || Date.now()),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [day, month, year].join('-');
  }
}


// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/header.service.ts